var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BuyButton',{attrs:{"model":_vm.buyButtonModel,"show-logos":_vm.showLogos,"guide-visible":_vm.guideVisible,"vendors-title":_vm.vendorsTitle,"lazy":_vm.lazy}})}
var staticRenderFns = []

export { render, staticRenderFns }